import { MantineReactTable } from "mantine-react-table";
import {
  ActionIcon,
  Box,
  Button,
  MantineProvider,
  Select,
} from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import { MRT_Localization_FA } from "mantine-react-table/locales/fa";
import { ExportAsExcel } from "react-export-table";
// import * as FileSaver from 'file-saver';
import "./DataTable.css";

const DataTable = ({
  tableRef,
  data = [],
  columns = [],
  hasAction = false,
  actionButtons = [],
  topToolbarButtons = [],
  topToolbarSelect = [],
  enableRowSelection = false,
  selectedRows = {},
  setSelectedRows,
  excelName = "گزارش",
  isLoading,
  cls,
  extend,
  ...props
}) => {
  // const ExportExcel = async (rows) => {
  //   const COL_WIDTH = 50;
  //   const header = columns.map((column) => column.header);
  //   const jsonData = rows.map((row) => row.original)
  //   const wb = XLSX.utils.book_new();
  //   const ws = XLSX.utils.json_to_sheet(jsonData, { header: header });
  //   XLSX.utils.book_append_sheet(wb, ws, "sheet1");
  //   XLSX.writeFile(wb, (excelName + '.xlsx'));
  // }

  const headers = columns.map((column) => column.header || " ");
  const excelData = data.map((row) =>
    columns.reduce((acc, column) => {
      acc[column.header] = row[column.accessorKey || column.id] || "";
      return acc;
    }, {})
  );

  return (
    <>
      <MantineProvider theme={{ dir: "rtl" }}>
        <div
          className={`custom-data-table ${cls}`}
          style={{ direction: "rtl" }}
        >
          <MantineReactTable
            ref={tableRef}
            columns={columns}
            data={data}
            enableRowSelection={enableRowSelection}
            state={{ rowSelection: selectedRows, isLoading: isLoading }}
            onRowSelectionChange={setSelectedRows}
            columnFilterDisplayMode="popover"
            paginationDisplayMode="pages"
            positionToolbarAlertBanner="bottom"
            localization={MRT_Localization_FA}
            enableRowActions={hasAction}
            positionActionsColumn="last"
            // mantineTableProps={{
            //         style: {
            //           width: "100%",
            //           borderCollapse: "collapse",
            //         },
            //       }}
            //       mantineTableHeadProps={{
            //         style: {
            //           position: "sticky",
            //           top: 0,
            //           zIndex: 1,
            //           backgroundColor: "#fff",
            //         },
            //       }}
            //       mantineTableContainerProps={{
            //         style: {
            //           maxHeight: "45vh",
            //           overflowY: "auto",
            //           overflowX: "auto",
            //         },
            //       }}

            renderRowActions={({ row }) => (
              <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                {actionButtons.map((btnData, index) => (
                  <ActionIcon
                    key={index}
                    color={btnData.color}
                    onClick={() => {
                      btnData.onClick(row);
                    }}
                  >
                    {btnData.icon}
                  </ActionIcon>
                ))}
              </Box>
            )}
            renderTopToolbarCustomActions={({ table }) => (
              <Box className="datatable-top-toolbar">
                {topToolbarSelect.map((selectData, index) => (
                  <Select
                    searchable
                    data={selectData.data}
                    key={index}
                    onChange={(value) => selectData.onChange(value)}
                    value={selectData.value}
                    labelProps={{ position: "right" }}
                    placeholder={selectData.placeholder}
                    autoComplete="true"
                    styles={{
                      item: {
                        textAlign: "right",
                        paddingRight: "5px",
                        fontSize: "12px",
                      },
                    }}
                  />
                ))}
                {topToolbarButtons.map((btnData, index) => (
                  <Button
                    key={index}
                    className={btnData?.className}
                    disabled={btnData?.disabled}
                    onClick={() => btnData.onClick(table)}
                  >
                    {btnData?.label}
                  </Button>
                ))}

                <ExportAsExcel
                  data={table.getSelectedRowModel().rows.map((row) => {
                    const rowData = {};
                    columns.forEach((column) => {
                      rowData[column.header] =
                        row.original[column.accessorKey || column.id] || "";
                    });
                    return rowData;
                  })}
                  headers={headers}
                  fileName={excelName}
                  name="sheet1"
                >
                  {(props) => (
                    <Button
                      {...props}
                      className="download-all-excel"
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      leftIcon={<IconDownload />}
                      variant="filled"
                    >
                      دریافت خروجی اکسل
                    </Button>
                  )}
                </ExportAsExcel>

                <ExportAsExcel
                  data={excelData}
                  headers={headers}
                  fileName={excelName}
                  name="sheet1"
                >
                  {(props) => (
                    <Button
                      {...props}
                      className="download-all-excel"
                      disabled={data.length < 1}
                      leftIcon={<IconDownload />}
                      variant="filled"
                    >
                      دریافت خروجی کل داده ها
                    </Button>
                  )}
                </ExportAsExcel>
                {extend}
              </Box>
            )}
          />
        </div>
      </MantineProvider>
    </>
  );
};

export default DataTable;
